import { Expose } from 'class-transformer'

export class Address {
  @Expose({ name: 'xid' })
  guid?: string

  company?: string

  consignee?: string

  phone?: string

  address1?: string

  address2?: string

  address3?: string

  city?: string

  state?: string

  @Expose({ name: 'postal_code' })
  postalCode?: string

  get asString() {
    return `${this.address1} ${this.address2} ${this.city}, ${this.state} ${this.postalCode}`
  }
}
